import React from "react";

const PAYPAL_PAYMENT_LINK = "https://www.paypal.com/ncp/payment/M6NVWCDP8H4S4";

/*
  M-PESA / STK PUSH FUNCTIONALITY COMMENTED OUT FOR LATER USE

  The old active modal, phone input, amount input, suggested amounts,
  manual M-Pesa fallback, phone normalization, and /api/stkpush submit handler
  are intentionally not rendered or executed.

  Receiver display: +254 711 160 437
  Local phone: 0711160437
  Suggested amounts: [250, 500, 1000, 5000]

  STK Push endpoint kept for later server-side use:
  fetch("/api/stkpush", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ phone: cleanPhone, amount: cleanAmount }),
  });
*/

const BackTheBuilderStrip = () => {
  const openPayPalPayment = () => {
    window.open(PAYPAL_PAYMENT_LINK, "_blank", "noopener,noreferrer");
  };

  return (
    <section className="relative z-20 border-y border-black bg-black text-white dark:border-white dark:bg-white dark:text-black">
      <div className="container mx-auto flex min-h-[260px] flex-col justify-center gap-8 px-6 py-12 sm:min-h-[300px] sm:flex-row sm:items-center sm:justify-between sm:py-16 lg:min-h-[360px]">
        <div>
          <h2 className="mt-4 max-w-3xl text-4xl font-normal leading-[0.92] tracking-[-0.065em] text-white dark:text-black sm:text-6xl md:text-7xl">
            Fuel the work. Keep the builder building.
          </h2>

          <p className="mt-6 max-w-2xl text-base leading-tight tracking-[-0.025em] text-white/68 dark:text-black/62 sm:text-xl">
            If the work helped, send a small PayPal tip and support more useful
            products, tools, and experiments.
          </p>
        </div>

        <button
          type="button"
          onClick={openPayPalPayment}
          className="inline-flex min-h-14 items-center justify-center rounded-full border border-white/20 bg-white px-8 py-4 text-[11px] font-semibold uppercase tracking-[0.16em] text-black transition hover:border-[var(--brand-green)] hover:bg-[var(--brand-green)] hover:text-white dark:border-black/20 dark:bg-black dark:text-white dark:hover:border-[var(--brand-blue)] dark:hover:bg-[var(--brand-blue)]"
          aria-label="Open PayPal payment link"
        >
          Send Tip
          <i className="bx bx-chevron-right ml-2 text-lg" />
        </button>
      </div>
    </section>
  );
};

export default BackTheBuilderStrip;
